import { render, staticRenderFns } from "./sticky-basic.mpx?vue&type=template&id=a827fc5c&isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex"
import script from "./sticky-basic.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex"
export * from "./sticky-basic.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex"
import style0 from "./sticky-basic.mpx?vue&type=style&index=0&id=a827fc5c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_2ad7e0ca%22%7D&isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports